// Eventstream is expecting keys that are prepended with the catalog name
// This takes a metadata object and returns an object with prepended keys
export function prependEventstreamCatalogToKeys(catalogName, eventstreamData) {
  return Object.entries(eventstreamData).reduce((obj, [key, value]) => Object.assign(obj, {
    [`${catalogName}_${key}`]: value
  }), {});
}